<template>
  <a-layout class="create-application-box">
    <a-card class="create-application" :bordered=false>
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <!-- <div slot="extra" style="cursor:pointer" v-if="pageLayout.introduction">
        <span @click="introductionVisible=true">
          <a-icon type="exclamation-circle" />{{pageLayout.introduction.title}}</span>
      </div> -->
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && !loading && initFinished">
        <common-form v-if="layout.type==='commonForm'" :ref="`commonForm_${layout.field}`" :layout="layout" :params="layout.field && params[layout.field]?params[layout.field]:{}" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @update="update" @event-relay="eventRelay"></common-form>
        <multi-form :ref="`multiForm_${layout.field}`" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]" :default-params="defaultParams" :can-edit="canEdit" :need-id="false" @changed-fields="onFieldChange" @update="update"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :default-file-none="defaultFillNone" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit" @changed-fields="onFieldChange"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'必填信息填写后，流程将自动显示'" v-if="loadedInfo && !loading"></approval-flow>
      <a-row style="margin:30px 0 24px;" v-if="loadedInfo && !loading">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="10">
          <a-button type="primary" :disabled="!canSubmit" @click="submit" style="width:120px;">提交</a-button>
        </a-col>
      </a-row>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-modal class="introductionModal" :title="pageLayout.introduction.title" v-if="pageLayout.introduction" v-model="introductionVisible" @ok="introductionVisible=false" :okText="'关闭'">
        <div>
          <pre style="font-size: 14px;color: rgba(0,0,0,0.65);line-height: 22px;text-align:left">{{pageLayout.introduction.description}}</pre>
        </div>
      </a-modal>
    </a-card>
  </a-layout>
</template>

<script>
import UUID from 'uuidjs';
import SvgIcAll from '../../assets/svg/ic-all-o.svg';
import CommonForm from '../../components/CommonForm.vue';
import MultiForm from '../../components/MultiForm.vue';
import Summation from '../../components/Summation.vue';
import ApprovalFlow from '../../components/ApprovalFlow.vue';
import Upload from '../../components/Upload.vue';
import { setTimeout } from 'timers';
import LayoutConfig from '../../utils/LayoutConfig.js';
import { layoutConfig } from '../../utils/mockData.js';
import {
  getLayoutApi,
  getPaymentDetail,
  createPayment,
  getApprovalFlow,
} from '../../services/CommonService.js';

export default {
  components: {
    SvgIcAll,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    Upload,
  },
  data() {
    return {
      defaultFillNone: false,
      introductionVisible: false,
      canEdit: true,
      breadcrumb: [
        {
          label: '发起申请',
          path: '',
        },
      ],
      cardHeight: 0,
      applicationTitle: '发起付款申请',
      params: {},
      defaultParams: {}, // 复制时需要用到创建用到的默认参数
      loading: false,
      loadedInfo: false,
      initDeafultInfo: false,
      canSubmit: true,
      pageLayout: {},
      approvalFlowInfo: [],
      summationInfo: {},
      requestParams: {},
      cancelSource: null,
    };
  },

  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      // 复制时清空附件
      this.defaultFillNone = true;
    }
    this.getPaymentDetail();
    this.getPaymentDefaultInfo();
    this.fetchLayout();
  },
  mounted() {
    if (!this.$route.query.id) {
      this.systemCacheTimer = setInterval(this.systemCache, 20000);
    }
  },
  beforeDestroy() {
    clearInterval(this.systemCacheTimer);
  },

  computed: {
    approvalFlowDependParams() {
      const params = _.cloneDeep(this.requestParams);
      if (this.requestParams.basicInfo && this.requestParams.total_pay) {
        return {
          type: this.requestParams.basicInfo.type,
          company_id: this.requestParams.basicInfo.company_id,
          total_pay: this.requestParams.total_pay,
        };
      }
    },
    //页面参数和默认值均请求结束
    initFinished() {
      let res = false;
      if (this.initDeafultInfo && this.loadedInfo) {
        res = true;
      } else {
        res = false;
      }
      return res;
    },
  },

  methods: {
    onFieldChange(e) {
      this.params = Object.assign({}, this.params, e);
      LayoutConfig.setAllParams(this.params);
      this.requestParams = _.cloneDeep(this.params);
    },
    setSummationInfo(e) {
      this.summationInfo = e;
      this.requestParams = _.cloneDeep(this.params);
      this.requestParams = Object.assign(
        this.requestParams,
        this.summationInfo,
      );
    },
    fetchLayout() {
      this.loading = true;
      getLayoutApi({ id: this.$route.query.id }).then(res => {
        if (res.status === 'success') {
          this.pageLayout = res.data;
          this.loading = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    fetchApprovalFlow() {
      this.approvalFlowInfo = [];
      this.cancelQuest();
      getApprovalFlow(this.requestParams, this).then(res => {
        if (res.status === 'success') {
          if (res.data && _.isArray(res.data)) {
            res.data.forEach((item, index) => {
              this.$set(this.approvalFlowInfo, index, item);
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPaymentDetail() {
      this.loadedInfo = false;
      getPaymentDetail({
        type: this.$route.query.type ? this.$route.query.type : 'create',
        id: this.$route.query.id,
      }).then(res => {
        if (res.status === 'success') {
          this.paramsBackup = _.cloneDeep(res.data);
          this.params.init = false;
          this.loadedInfo = true;
          this.params = Object.assign({}, this.params, res.data);
          LayoutConfig.setAllParams(this.params);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getPaymentDefaultInfo() {
      this.initDeafultInfo = false;
      getPaymentDetail({
        type: 'default',
      }).then(res => {
        if (res.status === 'success') {
          this.defaultParams = Object.assign({}, this.defaultParams, res.data);
          this.initDeafultInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submit() {
      let validateResult = true;
      Object.keys(this.$refs).forEach(key => {
        if (key.indexOf('commonForm') || key.indexOf('multiForm')) {
          this.$refs[key].forEach(item => {
            if (!item.validateFields()) {
              validateResult = false;
            }
          });
        }
      });
      if (validateResult) {
        this.canSubmit = false;
        delete this.requestParams.system_cache;
        clearInterval(this.systemCacheTimer);
        createPayment(this.requestParams).then(res => {
          if (res.status === 'success') {
            this.$Message.success('创建申请成功');
            this.$router.replace({
              name: 'myApplicationList',
              query: {
                apply_type: 1,
              },
            });
          } else {
            this.$Message.error(h =>
              h('span', {
                domProps: {
                  innerHTML: res.message,
                },
              }),
            );
            this.systemCacheTimer = setInterval(this.systemCache, 20000);
          }
          this.canSubmit = true;
        });
      }
    },
    systemCache() {
      createPayment({ ...this.requestParams, system_cache: true }).then(res => {
        if (res.status === 'success') {
        }
      });
    },
    update(e) {
      this.fetchLayout();
    },
    back() {
      this.$router.replace({
        name: 'launchApplication',
      });
    },
    getNeighorByField(val) {
      let vm = null;
      Object.keys(this.$refs).forEach(key => {
        const field = key.substr(key.indexOf('_') + 1);
        if (field === val) {
          vm = this.$refs[key];
        }
      });
      return vm[0];
    },
    eventRelay(e) {
      const self_event = e[0];
      let behind_event = _.cloneDeep(e);
      behind_event.shift();
      if (self_event.selfDo === 'emit') {
        this.$emit('event-relay', behind_event);
      } else if (self_event.selfDo === 'passNeighor') {
        let neighorVm = this.getNeighorByField(self_event.params.value);
        neighorVm.eventRelay(behind_event);
      }
    },
    cancelQuest() {
      if (typeof this.cancelSource === 'function') {
        this.cancelSource('终止请求'); //取消请求
      }
    },
  },
  watch: {
    approvalFlowDependParams: {
      handler(val) {
        if (
          val &&
          val.type &&
          val.company_id &&
          val.total_pay &&
          val.total_pay !== '0.00'
        ) {
          this.copyVal = _.cloneDeep(val);
          this.fetchApprovalFlow();
        }
      },
      deep: true,
    },
    initFinished: {
      handler(val) {
        if (val && !this.params.system_cache && !this.init) {
          //未缓存之前显示的是params和默认值defaultParams信息（因为后端parms里没有返默认值的信息，所以前端处理合并了）
          const defaultParams = _.cloneDeep(this.defaultParams);
          Object.keys(defaultParams).forEach(key => {
            if (this.params[key]) {
              defaultParams[key] = Object.assign(
                defaultParams[key],
                this.params[key],
              );
            }
          });
          this.params = {};
          this.params = Object.assign(
            {},
            this.params,
            _.cloneDeep(defaultParams),
          );

          LayoutConfig.setAllParams(this.params);
          this.init = true;
        }
      },
    },
  },
};
</script>

<style lang="less">
.create-application-box {
  padding: 16px;
}
.introductionModal {
  .ant-modal-footer {
    .ant-btn-default {
      display: none;
    }
  }
}
</style>
